<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Crear Práctica</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">

        <div class="card-body">
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <div class="row">

              <div class="col-6">
                <b-form-group id="input-group-3" label="Título:" label-for="input-category">
                  <b-form-group label-for="keyInput" >
                    <b-form-input id="keyInput"  v-model="form.title" required ></b-form-input>
                  </b-form-group>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label="Key" label-for="keyInput" >
                  <b-form-input id="keyInput"  v-model="form.key" required ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group label="Cantidad de preguntas para aprobar" label-for="keyInput" >
                  <b-form-input id="keyInput"  v-model="form.approve" required ></b-form-input>
                </b-form-group>
              </div>

              <div class="col-6">
                <input
                  type="checkbox"
                  v-model="form.isPremium"
                  :class="{ 'checked': form.isPremium }"
                />
                <span class="span-diagnostic">Es práctica premium</span>
              </div>
            </div>

            <b-button type="submit" variant="primary">Guardar</b-button>
          </b-form>
        </div>
      </div>
    </div>

    <!-- add Questions-->
    <div class="container-fluid" v-if="isEdit">
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div id="app" class="container">
          <div class="div-lessons">
            <h3>Preguntas:</h3>
            <div>
              <button class="btn btn-primary" @click="showModal()">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Preguntas
              </button>
              <button class="btn btn-primary ml-2" @click="showModalAddQuestionsRandom()">
                <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Agregar Preguntas Aleatoriamente
              </button>
            </div>
          </div>

          <br>
          <br>

          <table class="table">
            <thead>
              <tr >
                <th>Nombre unico</th>
              </tr>
            </thead>

            <tbody v-for="question in practiceQuestions.questions" :key="question.id">
              <tr >
                <td>{{question.uniqueName}}</td>
                <td></td>
                <td>
                  <button class="btn btn-secondary p-2 d-block w-100 ml-2"
                  v-on:click="deleteQuestion(question.id)">
                        Eliminar
                  </button>
                </td>
              </tr>
            </tbody>

            <tbody >
              <tr >
                <td colspan="2" class="td-nhd">No hay datos</td>
              </tr>
            </tbody>

          </table>
        </div>
      </div>

      <QuestionAdd ref="quesionAddComponent" @saveQuestion="saveQuestion"/>
      <QuestionsAddRandom ref="quesionAddRandomComponent" :parent-model="module"/>

    </div>
     <!-- /add Questions-->

  </div>
</template>

<script>
import axios from "axios";
import router from "../../../../router";
import QuestionAdd from "../Questions/QuestionsAdd.vue";
import QuestionsAddRandom from "../Questions/QuestionsAddRandom.vue"

export default {
  components: { QuestionAdd, QuestionsAddRandom },
  data() {
    return {
      form: {
        description: '',
        title: '',
        key: '',
        approve: '',
        isPremium: false,
      },
      show: true,
      practiceId: null,
      isEdit: false,
      searchQuestions: "",
      lessonsQuestions: [],
      practiceQuestions: [],
      module: 'practices',
    }
  },
  methods: {
    showModal() {
      this.$refs['quesionAddComponent'].showModal();
    },
    showModalAddQuestionsRandom() {
      this.$refs['quesionAddRandomComponent'].showModal();
    },
    onModalHide() {
      this.searchQuestions= '';
      this.lessonsQuestions= '';
    },
    deleteQuestion(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta pregunta?")){
        return
      }
      let loader = this.$loading.show({});
      axios
        .delete(
          import.meta.env.VITE_API_BASE_URL + "/api/practices/" + this.practiceId + "/questions/" + id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          console.log(response);
          loader.hide();
          this.$router.go();
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    saveQuestion(questionId) {

      this.practiceId = this.$route.params.id;
      var practiceId = parseInt(this.practiceId);
      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/practices/saveQuestion", {
        'practiceId': practiceId  , 'questionId': questionId
      }, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "Pregunta Guardado."
        );
        console.log(result);
        this.$router.go();
      }).catch((err) => {
        if (err.response.data === 'duplicated') {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
              "Error al crear, Ya se ha agregado esta pregunta antes"
          );
          console.log(err.message);
        }  else {
          this.$toastr.defaultTimeout = 2000; // default timeout : 5000
          this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
          this.$toastr.e(
            "Error al crear"
          );
          console.log(err.message);
        }
      });
    },
    onSubmit(event) {
      event.preventDefault();
      
      // Normalizar isPremium para asegurar que sea boolean
      this.form.isPremium = this.form.isPremium === true || this.form.isPremium === 'true';
      
      if (this.isEdit) {
        let loader = this.$loading.show({});
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        axios.put(import.meta.env.VITE_API_BASE_URL + "/api/practices/edit/" + this.practiceId , this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Practica Editada."
          );
          loader.hide();
          router.push({ path: `/admin-panel/practices` });
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al editar la práctica, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      }else {
        let loader = this.$loading.show({});
        axios.post(import.meta.env.VITE_API_BASE_URL + "/api/practices/save", this.form, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }}).then(() => {
          this.$toastr.s(
            "Práctica Guardada."
          );
          loader.hide();
          router.push({ path: `/admin-panel/practices` });
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
          this.$toasted.error("Error al crear la práctica, posiblemente ya exista alguna con los mismos datos y estado.", {position: 'top-right', duration: 5000});
        });
      }
    },
    onReset(event) {
      event.preventDefault()
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.practiceId = this.$route.params.id;
      this.isEdit = true;
      let loader = this.$loading.show({});
      axios.get(
        import.meta.env.VITE_API_BASE_URL + "/api/practices/" + this.practiceId,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          }
        }
      )
        .then((response) => {
          if (response.data === '') {
            console.log(response.data)
            this.practiceQuestions = [];
            return;
          }
          this.form.title = response.data.title;
          this.form.key = response.data.key;
          this.form.approve = response.data.approve;
          this.form.isPremium = response.data.isPremium || false;
          this.practiceQuestions = response.data
          loader.hide();
        }).catch((err) => {
          loader.hide();
          console.log(err.message);
        });
    }
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  },
}
</script>
